import { useState } from "react";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import BrandMarquee from "@/components/site/BrandMarquee";
import Services from "@/components/site/Services";
import Areas from "@/components/site/Areas";
import WhyChooseUs from "@/components/site/WhyChooseUs";
import Process from "@/components/site/Process";
import About from "@/components/site/About";
import FAQ from "@/components/site/FAQ";
import Contact, { Footer } from "@/components/site/Contact";
import WhatsAppButton from "@/components/site/WhatsAppButton";
import BookingDialog from "@/components/site/BookingDialog";

export default function Landing() {
  const [bookOpen, setBookOpen] = useState(false);
  const [selectedService, setSelectedService] = useState("");
  const openBook = (service) => {
    setSelectedService(typeof service === "string" ? service : "");
    setBookOpen(true);
  };

  return (
    <div className="bg-white overflow-x-hidden">
      <Navbar onBook={openBook} />
      <Hero onBook={openBook} />
      <BrandMarquee />
      <Services onBook={openBook} />
      <Areas onBook={openBook} />
      <WhyChooseUs />
      <Process />
      <About />
      <FAQ />
      <Contact onBook={openBook} />
      <Footer />
      <WhatsAppButton />
      <BookingDialog
        open={bookOpen}
        onOpenChange={setBookOpen}
        defaultService={selectedService}
      />
    </div>
  );
}
